import Cookies from 'js-cookie';

const hideElement = (selector) => {
    const elementToHide = document.querySelector(selector);

    if (elementToHide) {
        elementToHide.classList.add('hidden-by-cookies');
    }
};

const hideElementIfInCookie = (element) => {
    const selector = element.dataset.cookieHideElementSelector;

    if (Cookies.get(selector)) {
        hideElement(selector);
    }
};

const hideElementHandler = (element) => {
    const selector = element.dataset.cookieHideElementSelector;

    Cookies.set(selector, true, {
        expires: 1,
    });

    hideElement(selector);
};

export const cookieHideElementListener = () => {
    const elements = [...document.querySelectorAll('.js-cookie-hide-element')]
        .filter((el) => el.dataset.cookieHideElementSelector)
        .filter((el) => !el.dataset.cookieHideElementInitialized);

    elements.forEach((el) => {
        hideElementIfInCookie(el);

        el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            hideElementHandler(el);
        });
    });
};
